import { splitBalanced } from '../../../util';
import { css, cssPluginResetStyles } from '../core';
const paddingReset = {
    '--padding-top': css.value(0),
    '--padding-right': css.value(0),
    '--padding-bottom': css.value(0),
    '--padding-left': css.value(0),
    padding: css.value('var(--padding-top) var(--padding-right) var(--padding-bottom) var(--padding-left)')
};
const marginX = (value)=>({
        marginLeft: value,
        marginRight: value
    });
const marginY = (value)=>({
        marginTop: value,
        marginBottom: value
    });
const padding = (shorthand)=>{
    // shorthand value may be calc or var, so we need to be careful to match parens when splitting
    const [top, right, bottom, left] = splitBalanced((shorthand === null || shorthand === void 0 ? void 0 : shorthand.value.toString()) || '');
    var _ref;
    return {
        '--padding-top': css.value(top),
        '--padding-right': css.value(right !== null && right !== void 0 ? right : top),
        '--padding-bottom': css.value(bottom !== null && bottom !== void 0 ? bottom : top),
        '--padding-left': css.value((_ref = left !== null && left !== void 0 ? left : right) !== null && _ref !== void 0 ? _ref : top)
    };
};
function createPaddingPlugin(customProperty) {
    return function paddingPlugin(value, selector) {
        const paddingValue = customProperty ? {
            [customProperty]: value
        } : padding(value);
        return Object.assign({}, cssPluginResetStyles(selector, paddingReset), paddingValue);
    };
}
const paddingX = (value)=>({
        paddingLeft: value,
        paddingRight: value
    });
const paddingY = (value)=>({
        paddingTop: value,
        paddingBottom: value
    });
const negative = (value)=>value ? css.value(`calc(-1 * ${value})`) : undefined;
const bleedMap = {
    marginTop: '--padding-top',
    marginBottom: '--padding-bottom',
    marginLeft: '--padding-left',
    marginRight: '--padding-right'
};
function createBleedPlugin(...marginProperties) {
    return function bleedPlugin(value) {
        const properties = marginProperties.map((marginProperty)=>{
            if (value === 'auto') {
                const ancestorPaddingVar = `var(${bleedMap[marginProperty]})`;
                return {
                    [marginProperty]: negative(css.value(ancestorPaddingVar))
                };
            }
            return {
                [marginProperty]: negative(value)
            };
        });
        return Object.assign({}, ...properties);
    };
}
export const pluginsBoxModel = {
    marginX,
    marginY,
    padding: createPaddingPlugin(),
    paddingTop: createPaddingPlugin('--padding-top'),
    paddingBottom: createPaddingPlugin('--padding-bottom'),
    paddingLeft: createPaddingPlugin('--padding-left'),
    paddingRight: createPaddingPlugin('--padding-right'),
    paddingX,
    paddingY,
    bleed: createBleedPlugin('marginTop', 'marginBottom', 'marginLeft', 'marginRight'),
    bleedX: createBleedPlugin('marginLeft', 'marginRight'),
    bleedY: createBleedPlugin('marginTop', 'marginBottom'),
    bleedTop: createBleedPlugin('marginTop'),
    bleedBottom: createBleedPlugin('marginBottom'),
    bleedLeft: createBleedPlugin('marginLeft'),
    bleedRight: createBleedPlugin('marginRight')
};

//# sourceMappingURL=pluginsBoxModel.js.map